module.exports = __webpack_public_path__ + "img/alert_money.0e6f2677.svg";